import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import SuccessImg from "../../assets/images/success-order.svg";
import SuccessImgFood from "../../assets/images/success-food.svg";
import { centsToFloat, floatToPrice } from "../../functions/price_functions";

import { useAppConfig } from "../../hooks/useAppConfig";
import { FC, useEffect, useState } from "react";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";

import styles from "./index.module.css";
import { useOrder } from "../../hooks/useOrder";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { cpfMask, datetimeToDateBR } from "../../functions/mask";
import {
  OrderAddress,
  OrderType,
  ProductType,
} from "../../contexts/OrderContext";
import { MainButton } from "../../components/MainButton";
import Swal from "sweetalert2";
import { ImageLazy } from "../../components/ImageLazy";
import { CheckoutOrder } from "../../components/checkoutOrder/checkoutOrder";
import {
  SumaryOrder,
  SumaryOrderFinished,
} from "../../components/sumaryOrder/sumaryOrder.module";
import { InfoFinishedOrder } from "../../components/InfoFinishedOrder/InfoFinishedOrder";
import { InfoOrderItens } from "../../components/InfoOrderItens/InfoOrderItens";
import {
  InfoCustomer,
  InfoCustomerFinish,
} from "../../components/InfoCustomer/InfoCustomer";
import { InfoAddressOrder } from "../../components/InfoAddressOrder/InfoAddressOrder";
import { InfoSeller } from "../../components/InfoSeller/InfoSeller";
import { InfoPayment } from "../../components/InfoPayment/InfoPayment";
import { OrderObservation } from "../../components/OrderObservation/OrderObservation";
import usePreventNavigation from "../../components/PreventBackNavigation/PreventBackNavigation";
import { useParams } from "react-router-dom";
import { useDiscount } from "../../hooks/useDiscount";
import { useSellerCart } from "../../contexts/sellerCartContext";
import { useSellerInfo } from "../../contexts/sellerInfoContext";
import { IntegrationType } from "../NewChoosePayment/newChoosePayment.type";
import { useOrderMetaData } from "../../contexts/orderMetaDataContext/orderMetaDataContext";
import { Customer, DataGateway, OrderIntegrationPlanType, StatusResponseType } from "./newSuccessOrder.type";

const NewSuccessOrder: FC = () => {
  const { getAppConfig } = useAppConfig();
  const sellerCartContext = useSellerCart();
  const sellerInfoContext = useSellerInfo();
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const { metadataComplete } = useOrderMetaData();
  const { pluginspace_id } = useParams();
  const { dencryptOrderStorage } = useOrder();
  const [orderDate, setOrderDate] = useState("");
  const [status, setStatus] = useState<Array<StatusResponseType>>();
  const [statusOrder, setStatusOrder] = useState<StatusResponseType>();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();
  const [type, setType] = useState("");
  const [freight, setFreight] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);
  const [orderFinished, setOrderFinished] = useState<OrderType>();
  const [orderIdExt, setOrderIdExt] = useState("");
  const [typePluginSpace, setTypePluginSpace] = useState<string>("");
  const [observation, setObservation] = useState("");
  const [requestSynkar, setRequestSynkar] = useState("");
  const [externalCodeERP, setExternalCodeERP] = useState("");
  const [sellerInfo, setSellerInfo] = useState<any>(null);
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [customer, setCustomer] = useState<Customer>();
  const [gateWayInfo, setGateWayInfo] = useState<DataGateway>();
  const [changePaymentValue, setChangePayment] = useState(0);
  const [cupomDiscount, setCupomDiscount] = useState("");
  const [paymentDiscount, setPaymentDiscount] = useState<{
    type: string;
    discountValue: string;
  } | null>();
  const [installment, setInstallment] = useState(0);
  const [installmentValue, setInstallmentValue] = useState(0);
  const [integrationPlanLocal, setIntegrationPlanLocal] =  useState<OrderIntegrationPlanType>();

  const discountContext = useDiscount();

  useEffect(() => {
    registerAccess("success-order");
    discountContext.clearAllDiscounts();
    sellerCartContext.clearSellerCart();
    sellerInfoContext.clearSellerInfo();
    getConfig();
  }, []);

  const trunCat = (num: number, decimals: number) => {
    const formatter = Math.pow(10, decimals);
    const res = Math.floor(num * formatter) / formatter;
    return res;
  };
  async function getConfig() {
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    const type = await getThisPluginspace();

    setTypePluginSpace(type!.type);

    const orderIdExtNow = metadataComplete.orderIdExt//await loadOrder();
    await getOrder(orderIdExtNow);


    setInterval(async () => {
      if (window.location.pathname.includes("success-order")) {
        await getOrder(orderIdExtNow);
      }
    }, 30000);

    await getStatus();

    setLoading(false);
  }

  async function getOrder(orderIdExtNow?: string) {
    let customerCPF = 0;

    await api
      .post(
        `/api/orders/ext/${orderIdExtNow ? orderIdExtNow : orderIdExt}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        const orderResponse = response.data;
        if (!orderResponse || !orderResponse.success) {
          Swal.fire({
            title: "Erro",
            text: "Não foi possível carregar o pedido.",
            icon: "error",
            confirmButtonText: "Ok",
          });
          return;
        }

        const data: any = orderResponse.data[0];

        setOrderDate(datetimeToDateBR(data.created));
        setObservation(data.observation || "");
        setName(data.content.customer);
        setStatusOrder(data.status[0]);

        customerCPF = data.content.customerCpf
          ? data.content.customerCpf
          : data.content.cpfOrder;

        const externalCodeERPValue = (data.content as any).externalCodeERP;
        if (externalCodeERPValue) {
          setExternalCodeERP(externalCodeERPValue);
        }

        if (data.cartCustomer && (data.cartCustomer as any).seller) {
          setSellerInfo((data.cartCustomer as any).seller);
        }

        if (data.content.dataGateway) {
          setGateWayInfo(data.content.dataGateway as unknown as DataGateway);
        }

        if (data.content.orderAddress) {
          setOrderAddress(data.content.orderAddress as unknown as OrderAddress);
        }

        setFreight(data.content.deliveryFee / 100 || 0);
        setChangePayment(data.content.changeMoney / 100 || 0);
        setType(data.type || "");
        setOrderIdExt(data.orderidExt || "");


     
        let discountByProducts = 0
        let totalProduct = 0


        const mappedProducts: ProductType[] = data.products.map((product: any) => {
          const unitPrice = product.price ? product.price / 100 : 0;
          const promotionalPrice = Math.max(0, (product.price) / 100);
          let variation: any = product.content.variation;

          discountByProducts += product.discount ? parseInt(product.discount) * product.quantity / 100 : 0;
          
          const discountProduct = product.discount ? parseInt(product.discount) / 100 : 0;
          
          variation = product.content.variation;


          totalProduct += (unitPrice + discountProduct) * product.quantity;

          return {
            id: product.id,
            name: product.content.productName,
            image: product.content.image,
            mark: "",
            unitPrice: unitPrice + discountProduct,
            promotionalPrice: promotionalPrice,
            quantity: product.quantity,
            stock: 0,
            sku: product.sku,
            variation: variation,
            code: product.code,
            locationId: data.locationId,
            pluginspaceHash: "",
            outStock: false,
            measures: product.content.measures || null,
            observation: product.content.observation || undefined,
          };
        });

        setTotal(totalProduct - discountByProducts);
        setTotalWithoutDiscount(totalProduct);

        setOrderFinished({ products: mappedProducts } as OrderType);

        setPaymentDiscount(null);
        setInstallment(data.content.dataGateway?.portion_numInstallments || 1);
        setInstallmentValue(
          trunCat(
            totalProduct / (data.content.dataGateway?.portion_numInstallments || 1),
            2
          )
        );

        setIntegrationPlanLocal(
          data.content.dataGateway?.paymentData
            ? {
              codePay: data.content.dataGateway.codePay,
              codePlan: data.content.dataGateway.codePlan,
              nameGateway: data.content.dataGateway.gatewayName,
              paymentItemData:
                data.content.dataGateway.paymentData as unknown as IntegrationType,
              nameBrand: data.content.dataGateway.paymentData.brand,
              typePayment: data.content.dataGateway.paymentData.typePay,
            }
            : undefined
        );
      })
      .catch((err) => {
        console.log(err);
        return null;
      });

    if (customerCPF) {
      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: customerCPF,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response) => {
          const orderResponse = response.data;

          if (orderResponse.success) {
            const customer = orderResponse.data[0];
            setCustomer(customer);
          }
        })
        .catch((err) => {
          console.log(err);
          return null;
        });
    }
  }

  async function getStatus() {
    await api
      .get(`/api/status`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        const statusReponse = response.data;
        const sts = statusReponse.data.filter(
          (manyStatus: StatusResponseType) =>
            manyStatus.displayStatusWebapp === true
        );
        setStatus(
          sts.sort((a: StatusResponseType, b: StatusResponseType) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
          )
        );
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }
 

  usePreventNavigation(`/${pluginspace_id}/category`);

  return (
    <div className="success">
      <div
        className={`${styles.content_success} ${loading ? "" : styles.content_success_loading
          }`}
      >
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className={styles.success_body}>
            <CheckoutOrder position={5} name={"Conclusão"} />
            <InfoFinishedOrder
              externalCodeERP={externalCodeERP}
              orderIdExt={orderIdExt}
              status={status}
              statusOrder={statusOrder}
              config={config}
              type={type}
            />
            <SumaryOrderFinished
              totalWithoutDiscount={totalWithoutDiscount}
              total={total}
              freight={freight}
              type={type}
            />
            {gateWayInfo && (
              <InfoPayment
                gateWay={gateWayInfo as any}
                changePaymentValue={changePaymentValue}
                cupomDiscount={cupomDiscount}
                paymentDiscount={paymentDiscount}
                installment={installment}
                installmentValue={installmentValue}
                integrationPlanLocal={integrationPlanLocal as any}
              />
            )}
            {orderAddress && (
              <InfoAddressOrder
                orderAddress={orderAddress}
                type={type}
                freight={freight}
                config={config}
              />
            )}
            <InfoCustomerFinish customer={customer} />
            <InfoSeller sellerInfo={sellerInfo} />
            <InfoOrderItens order={orderFinished} config={config} />
            {config?.content.pdv.showObservation && (
              <OrderObservation
                observation={observation}
                setObservation={setObservation}
                readonly={true}
              />
            )}
          </div>
        )}
        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
};

export { NewSuccessOrder };
